import { FC, ReactNode } from 'react';

import CloseIcon from './close-icon';
import {
  CancelButton,
  CloseButton,
  ConfirmButton,
  Description,
  ModalTitle,
  StyledActionsBox,
  StyledDialog,
  StyledHeader,
} from './confirm-modal.styled';

interface ConfirmModalProps {
  open: boolean;
  isLoading: boolean;
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  loadingLabel?: string;
  width?: number;
  dataTestId?: string;
  cancelTestId?: string;
  confirmTestId?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  isLoading,
  title,
  description,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  loadingLabel = 'Deleting...',
  width,
  dataTestId,
  cancelTestId,
  confirmTestId,
  onClose,
  onConfirm,
}) => (
  <StyledDialog
    open={open}
    onClose={onClose}
    $width={width}
    data-testid={dataTestId}
  >
    <StyledHeader>
      <ModalTitle>{title}</ModalTitle>
      <CloseButton type="button" onClick={onClose} aria-label="Close">
        <CloseIcon />
      </CloseButton>
    </StyledHeader>

    {description && <Description>{description}</Description>}

    <StyledActionsBox>
      <CancelButton
        type="button"
        disabled={isLoading}
        data-testid={cancelTestId}
        onClick={onClose}
      >
        {cancelLabel}
      </CancelButton>
      <ConfirmButton
        type="button"
        disabled={isLoading}
        data-testid={confirmTestId}
        onClick={onConfirm}
      >
        {isLoading ? loadingLabel : confirmLabel}
      </ConfirmButton>
    </StyledActionsBox>
  </StyledDialog>
);

export default ConfirmModal;
